let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lxF53")).then(() => parcelRequire('g06Y9'));